import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

export default function ResponsivenessScoreContentListing({ score }) {
    if (score !== null) {
        return (
            <div className="content-listing-details__tags">
                <span className="meta-data-item--small">
                    <span className="meta-data-item__icon">
                        <span className="icon icon--alarm-1" />
                    </span>
                    <span className="meta-data-item__label">
                        <FormattedMessage
                            id="responsiveness_score_invitation"
                            values={{
                                percentage: score,
                            }}
                        />
                    </span>
                </span>
            </div>
        );
    }
    return null;
}

ResponsivenessScoreContentListing.propTypes = {
    score: PropTypes.number,
};

ResponsivenessScoreContentListing.defaultProps = {
    score: null,
};



// WEBPACK FOOTER //
// ./src/js/apps/responsiveness-score/components/responsiveness-score-content-listing.jsx